<template>
    <div class='staff-detail'>
        <bread-crumb :list="[{
            text: '员工管理',
            url: '/main/staff/nav/staffList'
        }, {
            text: '员工详情'
        }]"/>
        <!-- 员工信息 -->
        <!-- <up-down v-loading="isLoading" :isDeleted="staffInfo.status === 1" :showEdit="true" minWidth="1068px" @change="isUp = $event" @edit="editStaffInfo"> -->
        <up-down v-loading="isLoading" :isDeleted="staffInfo.status === 1" minWidth="1068px" @change="isUp = $event" @edit="editStaffInfo">
            <div slot="down" class="my-down fx-v-center" :class="{ 'deleted': staffInfo.status === 1 }">
                <user-info :userInfo="staffInfo.user || {}"
                :maxWidth="'300px'"/>
                <span class="phone">&nbsp;/&nbsp;{{ get(staffInfo, 'user.phone') || '未设置' }}</span>
                <div class="common-role super-admin ml-4" v-if="staffInfo.permission_list && staffInfo.permission_list.includes(0)">{{ '超级管理员' }}</div>
            </div>
            <div slot="up" class="my-up fx-v-center" :class="{ 'deleted': staffInfo.status === 1 }">
                <div class="my-up-left fx-v-center pr-20">
                    <div class="img-box" :class="'img-box-' + get(staffInfo, 'user.gender')">
                        <img :src="get(staffInfo, 'user.avatar')" alt="">
                    </div>
                    <div class="staff-info">
                        <p class="wx-info fs-16 mb-6">
                            <span class="fw-600 color-333">{{ get(staffInfo, 'user.nickname')}}</span><span class="color-999" v-if="get(staffInfo, 'user.realname')">({{ get(staffInfo, 'user.realname') }})</span>
                        </p>
                        <p class="phone color-999 mb-6">{{ get(staffInfo, 'user.phone') || '未设置' }}</p>
                        <div class="common-role super-admin" v-if="staffInfo.permission_list && staffInfo.permission_list.includes(0)">{{ '超级管理员' }}</div>
                        <!-- <div v-if="staffInfo.permission_list && staffInfo.permission_list.length > 0"
                            class="fx-v-center role color-999">
                            <div class="common-role super-admin" v-if="staffInfo.permission_set.is_super_admin_permission_set">{{ staffInfo.permission_set.name }}</div>
                            <div class="common-role" v-else>{{ staffInfo.permission_set.name }}</div>
                        </div> -->
                    </div>
                </div>
                <div class="my-up-right fx-h-center fs-14 pl-20">
                    <div class="fx-v-center mb-6">
                        <div class="info-item fx-v-center">
                            真实姓名：
                            <span class="text-popper" v-textPopper>{{ get(staffInfo, 'user.realname') || '未设置' }}</span>
                        </div>
                        <div class="info-item fx-v-center">
                            员工生日：
                            <span class="text-popper" v-textPopper>{{ get(staffInfo, 'user.birthday') || '未设置' }}</span>
                        </div>
                    </div>
                    <div class="fx-v-center mb-6">
                        <div class="info-item fx-v-center">
                            员工职位：
                            <span class="text-popper" v-textPopper>{{ staffInfo.position || '未设置' }}</span>
                        </div>
                        <div class="info-item fx-v-center">
                            入职时间：
                            <span class="text-popper" v-textPopper>{{ staffInfo.entry_date || '未设置' }}</span>
                        </div>
                    </div>
                    <div class="remark fx-v-center">
                        备注：<span class="color-red text-popper" v-textPopper>{{ staffInfo.remarks }}</span>
                    </div>
                </div>
            </div>
        </up-down>
        <!-- components -->
        <edit-and-add-staff-info
            :visible.sync="isShowEditStaff"
            :mode="'update'"
            :staffId="curStaffId"/>
        <!-- 交接班记录 -->
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="交接班记录" name="changeShiftsRecord"/>
        </el-tabs>
        <router-view :style="{ height: isUp ? 'calc(100vh - 285px)' : 'calc(100vh - 243px)' }"/>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref, onBeforeMount } from '@vue/composition-api'
import BreadCrumb from '@/components/bread_crumb/bread_crumb.vue'
import UpDown from '@/components/up_down/up_down.vue'
import EditAndAddStaffInfo from '../modules/edit_and_add_staff_info.vue'
import $fetch from '../../../api'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { openMessage } from '../../../utils/system'

export default createComponent({
    setup(props, ctx) {
        const oRoute = ctx.root.$route
        const oRouter = ctx.root.$router
        const query = oRoute.query
        const params = oRoute.params
        const id: string | Array<string | null> = query.id
        let curTabName = oRoute.path.split('/')[oRoute.path.split('/').length - 1]
        const intId: number = +id
        // reactive data
        const activeTabName = ref(curTabName)
        const staffInfo = ref<{ [propName: string]: any }>({})
        const isUp = ref(false)
        const isShowEditStaff = ref(false)
        const isLoading = ref(false)
        const curStaffId = ref<number>(intId)

        onBeforeMount(() => {
            if (intId) {
                getStaffInfo()
            } else {
                openMessage('error', '没有提供员工id，无法查询相关信息')
            }
        })

        async function getStaffInfo() {
            try {
                isLoading.value = true
                const result = await $fetch.post({
                    url: '/staff/getstaffinfo',
                    params: {
                        staff_id: intId
                    }
                })
                console.log('员工信息', clone(result))
                staffInfo.value = result
                return result
            } catch (e) {
                openMessage('error', e.message || '获取员工信息失败')
            } finally {
                isLoading.value = false
            }
        }

        const handleTabClick = (tab: { paneName: string }) => {
            const paneName = tab.paneName
            if (paneName === curTabName) { return }
            curTabName = paneName
            oRouter.replace({
                path: paneName,
                query,
                params
            })
        }

        function editStaffInfo() {
            isShowEditStaff.value = true
        }

        return {
            // data
            isLoading,
            isUp,
            activeTabName,
            isShowEditStaff,
            curStaffId,
            staffInfo,
            // methods
            get,
            handleTabClick,
            editStaffInfo
        }
    },
    components: {
        BreadCrumb,
        UpDown,
        EditAndAddStaffInfo
    }
})
</script>

<style lang="scss" scoped>
.my-down {
    ::v-deep .user-info {
        font-size: 16px;
        font-weight: bolder;

        .small-avatar {
            width: 30px;
            height: 30px;
        }

        .realname {
            color: #666;
            font-weight: normal;
        }
    }

    &.deleted {
        * {
            color: #999 !important;
            border-color: #999 !important;
        }

        ::v-deep .user-info .realname {
            color: #999;
        }
    }

    .phone {
        font-size: 16px;
        color: #666;
        vertical-align: middle;
    }

    .role {
        margin-left: 20px;
    }
}

.my-up {
    width: 100%;

    &.deleted * {
        color: #999 !important;
        border-color: #999 !important;
    }

    &-left {
        .img-box {
            width: 60px;
            height: 60px;
            margin-right: 8px;
            border-radius: 50%;
            box-sizing: border-box;
            border: 1px solid #999;
            background: #999;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
            }

            &-0 {
                border: 1px solid #999;
            }

            &-1 {
                border: 1px solid #3c90ff;
            }

            &-2 {
                border: 1px solid #ee5b5b;
            }
        }
    }

    &-right {
        flex: 1;
        flex-flow: column wrap;
        border-left: 1px solid #ddd;

        .info-item {
            height: 20px;

            span {
                width: 126px;
                vertical-align: middle;
            }
        }

        .remark {
            height: 20px;

            span {
                display: inline-block;
                width: 336px;
                vertical-align: middle;
            }
        }
    }
}
</style>
